import {
    type Block,
    type Inline,
    isBlockRangeSelection,
    type SelectionRange,
} from '@gitbook/slate';

/**
 * Check if a node can safely be replaced by a virtual placeholder.
 *
 * Virtualizing a node destroys the DOM that the native selection points into, so a node holding
 * either endpoint of the selection — at any depth — must always be rendered.
 */
export function canVirtualizeNode(props: {
    node: Block | Inline;
    selection: SelectionRange;
    excludeKeys?: ReadonlySet<string> | null;
}): boolean {
    const { node, selection, excludeKeys } = props;

    for (const key of getSelectionEndpoints(selection)) {
        if (node.hasNode(key)) {
            return false;
        }
    }

    if (excludeKeys) {
        for (const key of excludeKeys) {
            if (node.hasNode(key)) {
                return false;
            }
        }
    }

    return true;
}

/**
 * The keys the selection is anchored to, which differ by selection kind: a text range points at
 * text nodes, a block range at blocks.
 */
function getSelectionEndpoints(selection: SelectionRange): Array<string | null> {
    return isBlockRangeSelection(selection)
        ? [selection.anchorBlock, selection.focusBlock]
        : [selection.anchorKey, selection.focusKey];
}
